import { Flex } from '@chakra-ui/react'
import React from 'react'
import Details from './details'

interface SessionOverviewProps {
  session: any
  refetchSession: () => void
  client: any
  progressNote: any
  transcriptModalIsOpen: boolean
  setTranscriptModalIsOpen: (isOpen: boolean) => void
}

export const SessionOverview = ({
  session,
  refetchSession,
  client,
  progressNote,
  transcriptModalIsOpen,
  setTranscriptModalIsOpen
}: SessionOverviewProps) => {
  if (!client || !session) {
    return null
  }

  return (
    <Flex gap="24px" flexDirection="column" width="100%">
      <Details
        session={session}
        progressNote={progressNote}
        client={client}
        refresh={refetchSession}
        transcriptModalIsOpen={transcriptModalIsOpen}
        setTranscriptModalIsOpen={setTranscriptModalIsOpen}
      />
    </Flex>
  )
}
